/*
#*===================================================================
#*
#* Licensed Materials - Property of Zuum Transportation Inc.
#*
#* Copyright Zuum 2015-2023. All Rights Reserved.
#*
#*===================================================================
*/

import { createAction, props } from '@ngrx/store';
import { ApiManagementConfigDTO } from '@settings/api-management/shared';

export const loadApiConfgis = createAction('[Settings:Api Management] Load Api Management Configs');
export const loadApiConfgisSuccess = createAction(
  '[Settings:Api Management] Load Api Management Configs Sucess',
  props<{ configs: ApiManagementConfigDTO[] }>()
);

export const openDialiog = createAction(
  '[Settings:Api Management] Open Dialog',
  props<{ configs: ApiManagementConfigDTO[]; edit: boolean; config: Partial<ApiManagementConfigDTO> | null }>()
);

export const createConfig = createAction(
  '[Settings:Api Management] Create Config',
  props<{ config: Partial<ApiManagementConfigDTO> }>()
);
export const createConfigSuccess = createAction(
  '[Settings:Api Management] Create Config Success',
  props<{ config: ApiManagementConfigDTO }>()
);

export const updateConfig = createAction(
  '[Settings:Api Management] Update Config',
  props<{ config: Partial<ApiManagementConfigDTO> }>()
);
export const updateConfigSuccess = createAction(
  '[Settings:Api Management] Update Config Success',
  props<{ config: ApiManagementConfigDTO }>()
);

export const deleteDialog = createAction('[Settings:Api Management] Delete Dialog', props<{ id: number }>());
export const deleteConfig = createAction('[Settings:Api Management] Delete Config', props<{ id: number }>());
export const deleteConfigSuccess = createAction(
  '[Settings:Api Management] Delete Config Success',
  props<{ id: number }>()
);

export const failure = createAction('[Settings:Api Management] Failure', props<{ errorMessage: string }>());
